<section id="services">
    <div class="container contentPlacement">
        <h1 class="title">{{title | uppercase}}</h1>
        <div class="information col">
            <p class="subtitle">We can help to turn your ideas into reality.</p>
            <p class="subtitle">Write to us if you need help analyzing your idea or if you have problems with your current software. Feel free to contact us also when you would like to learn more about us.</p>
        </div>
    </div>
</section>
